import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"plus-circle\">\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <g transform=\"translate(3.000000, 3.000000)\" stroke=\"currentColor\" stroke-width=\"1\">\n            <circle id=\"plus-circle_Oval\" cx=\"9\" cy=\"9\" r=\"9\" />\n            <path d=\"M9,5.4 L9,12.6\" />\n            <path d=\"M5.4,9 L12.6,9\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol